import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Tooltip } from '@mantine/core';
import { upscaleSettingScalesList } from '@shakkerai/pro-constants';
import { NumberInputGroup, GenerateButton, ButtonGroup } from '@shakkerai/pro-components';
import { _useCanvasState, getCanvasState } from '@shakkerai/pro-store';
import { updateGenerateParams, updateTempState } from '@shakkerai/pro-store';
import { GeneratorPanelFooter } from '../generator/footer';
import { translate } from '@shakkerai/util-i18n';
import { Icon } from '@shakkerai/components';
import { SizeInputGroup } from '../generator/size';
import { Preparing } from './preparing';

const LENGTH_LIMIT = 8192;

export const upscaleOptions = [
  { value: '1', label: translate('upscale_tile_moredetail') },
  { value: '2', label: translate('upscale_tile_hdr') },
];

export const Upscaler = (props) => {
  return null;
};
